import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateAssessmentForm from "./CreateAssessmentForm";
import AssessmentTable from "./AssessmentTable";
import EditAssessment from "./EditAssessment";
import { ASSESSMENT_TYPES, labelsFor } from "./assessmentType";

function Assessment({
  subjectId = null,
  classId = null,
  canCreate = false,
  onCallback = console.log,
  classesUrl = "/teachers/classes",
  type = ASSESSMENT_TYPES.exam,
}) {
  const navigate = useNavigate();
  const labels = labelsFor(type);
  const [createAssessment, setCreateAssessment] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (selected) {
      onCallback(false);
    } else {
      onCallback(true);
    }
  }, [selected]);

  return (
    <>
      {selected ? (
        <>
          <EditAssessment
            id={selected?.id}
            type={type}
            classesUrl={classesUrl}
            onBack={() => {
              setSelected(null);
              navigate(-1);
            }}
          />
        </>
      ) : (
        <div className="py-10 ">
          <div
            style={{ borderRadius: "10px", color: "#616161" }}
            className=" bg-white drop-shadow-md w-full "
          >
            <div className="pt-8">
              <div className="h-16">
                <div
                  style={{ backgroundColor: "#09617E" }}
                  className="uppercase rounded-tl-xl text-white rounded-tr-xl h-full
                            font-normal text-base flex items-center justify-center relative"
                >
                  <h1 className="text-white font-bold">{labels.upper}</h1>
                  {canCreate && (
                    <div className="absolute  items-center justify-center top-1/4 right-6">
                      <Button
                        onClick={() => setCreateAssessment(true)}
                        className="w-40"
                        type="secondary"
                      >
                        Create {labels.one}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              <Modal
                title={`Create ${labels.one}`}
                width={800}
                visible={createAssessment}
                onOk={() => setCreateAssessment(false)}
                onCancel={() => setCreateAssessment(false)}
                footer={null}
              >
                <div>
                  <CreateAssessmentForm
                    type={type}
                    subject_id={subjectId}
                    class_id={classId}
                    classesUrl={classesUrl}
                    onCancel={() => setCreateAssessment(false)}
                  />
                </div>
              </Modal>

              <div>
                <AssessmentTable
                  type={type}
                  onClick={(data) => setSelected(data)}
                  subjectId={subjectId}
                  classId={classId}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Assessment;
